import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../config/environments/environment';
import { Observable } from 'rxjs';
import { ClassRoom } from '../models/interfaces/class-room.interface';
import { SegmentTree } from '../models/interfaces/segment-tree.interface';
import { ClassroomFilterDto } from '../models/dto/classroom-filter.dto';

@Injectable()
export class ClassRoomsService {
  constructor(private http: HttpClient) {}

  /**
   * @deprecated
   * Não está sendo usado ...
   */
   public getAll(): Observable<ClassRoom[]> {
    return this.http.get<ClassRoom[]>(`${environment.api.baseUrl}/classrooms`);
  }

   public getTree(filter?: ClassroomFilterDto): Observable<SegmentTree[]> {
    return this.http.get<SegmentTree[]>(
      `${environment.api.baseUrl}/classrooms-tree`,
      { params: this.buildParams(filter) }
    );
  }

   public getYears(filter?: ClassroomFilterDto): Observable<string[]> {
    return this.http.get<string[]>(
      `${environment.api.baseUrl}/classrooms/years`,
      { params: this.buildParams(filter) }
    );
  }

  public getById(id: string): Observable<ClassRoom> {
    return this.http.get<ClassRoom>(
      `${environment.api.baseUrl}/classrooms/${id}`
    );
  }

  private buildParams(filter?: ClassroomFilterDto): HttpParams {
    let params = new HttpParams();
    params = filter!.year
      ? params.set('year', filter!.year)
      : params;
    params = filter!.idSchool
        ? params.set('idSchool', filter!.idSchool)
        : params;
    return params;
  }   
}
